module.exports = __webpack_public_path__ + "static/media/ic_redo_selected.1f14ac6f.svg";